/**
 * @generated SignedSource<<5bfef8a5a51146cc77cbcadca7377866>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResultBuyingCreditsOperation = "FAILED" | "SUCCESS" | "SUCCESS_FOR_TRIAL" | "WAITING_FOR_APPROVAL";
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_SIDE_GENERATOR" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "TEST_ORDERS" | "VECTORIZE";
export type ServiceRechargeCreditsInput = {
  autoRefill: boolean;
  credits: number;
  currencyCode: string;
  expirationDate?: string | null;
  isForTrial?: boolean | null;
  isForTrialOnFirstPackage?: boolean | null;
  returnUrlFromApproval?: string | null;
  service: ServicesWithCredits;
  shopifyChargeID?: string | null;
};
export type serviceCreditsBuyTestOrdersMutation$variables = {
  input: ServiceRechargeCreditsInput;
};
export type serviceCreditsBuyTestOrdersMutation$data = {
  readonly buyTestOrders: {
    readonly errorMessage: string | null;
    readonly result: ResultBuyingCreditsOperation;
    readonly urlForApproval: string | null;
  } | null;
};
export type serviceCreditsBuyTestOrdersMutation = {
  response: serviceCreditsBuyTestOrdersMutation$data;
  variables: serviceCreditsBuyTestOrdersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ServiceBuyingResultOperation",
    "kind": "LinkedField",
    "name": "buyTestOrders",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlForApproval",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceCreditsBuyTestOrdersMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "serviceCreditsBuyTestOrdersMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "78c910791873ec1fb9ed41d98c52bc15",
    "id": null,
    "metadata": {},
    "name": "serviceCreditsBuyTestOrdersMutation",
    "operationKind": "mutation",
    "text": "mutation serviceCreditsBuyTestOrdersMutation(\n  $input: ServiceRechargeCreditsInput!\n) {\n  buyTestOrders(input: $input) {\n    errorMessage\n    result\n    urlForApproval\n  }\n}\n"
  }
};
})();

(node as any).hash = "e09c4812352274db658e5673eebfdea2";

export default node;
